import { EgButtonComponent } from "../components/eg-button/eg-button.component";
import { EgCheckboxComponent } from "../components/eg-checkbox/eg-checkbox.component";
import { EgDatepickerComponent } from "../components/eg-datepicker/eg-datepicker.component";
import { EgDropdownComponent } from "../components/eg-dropdown/eg-dropdown.component";
import { EgInputComponent } from "../components/eg-input/eg-input.component";
import { EgRadioButtonComponent } from "../components/eg-radio-button/eg-radio-button.component";
import { EgTextareaComponent } from "../components/eg-textarea/eg-textarea.component";

export const dynComponents = {
    inputText : EgInputComponent,
    textArea : EgTextareaComponent,
    button : EgButtonComponent,
    dropdown : EgDropdownComponent,
    checkbox :  EgCheckboxComponent,
    radio : EgRadioButtonComponent,
    datepicker : EgDatepickerComponent,
}


export interface iformField {
    [key: string]: any;
    dataField?: string;
    controlName: string;
    controlType: string;
    fieldLabel: string;
    inputType?: any;
    readOnly?: boolean;
    initialValue?: any | any[];
    options?: any[];
    multipleOptions?: boolean;
    promptText?: string;
    optionsSize?: number;
    minValue?: number;
    maxValue?: number; 
    stepValue?: number;

}

export type dynamicControlType = 
| 'textArea'
// | 'dropdwon'